import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Form, Input, Typography, Button, Flex } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { toastService } from "../../../../common/toast-messages/toast";
import { setNewProviderPassword } from "../../../../../redux/services/auth/authServices";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { sanitizeDataTypeClientSide } from "../../../../../utils/utils";
import { colors } from "../../../../../constants/colors";
import useUserToken from "../../../../../hooks/useToken";
import { appConfig } from "../../../../../constants/config/appConfig";
import styles from "./NewPassword.module.scss";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
const { Title } = Typography;

const NewPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  /* token dependencies */
  const [userToken, setUserToken] = useUserToken(appConfig.SESSION_USER_TOKEN);
  /* token dependencies */

  const onFinish = (values) => {
    if (values) {
      let setPasswordBody = {
        password: values.password2,
      };

      if (values.password1 === values.password2) {
        dispatch(
          setNewProviderPassword(
            setPasswordBody,
            navigate,
            setLoading,
            setUserToken
          )
        );
      } else {
        toastService.error(t("ResetPassword.confirmPasswordText"));
      }
    }
  };

  return (
    <>
      <Flex vertical gap="1rem" className={styles.setNewPasswordContainer}>
        <Title level={1} style={{ color: colors.primaryColor }}>
          {t("ResetPassword.title")}
        </Title>
        <Title level={4} type="secondary" style={{ margin: 0 }}>
          {t("ResetPassword.subTitle")}
        </Title>
        <Form
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          requiredMark={false}
        >
          <Flex vertical gap="6rem">
            <div>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("ResetPassword.newPasswordLabel")}
                    required={true}
                  />
                }
                name={"password1"}
                className={styles.labelTextStyle}
                rules={[
                  {
                    required: true,
                    message: t("ResetPassword.newPasswordErrorMessage"),
                  },
                  {
                    validator: (_, value) => {
                      if (value && /\s/.test(value)) {
                        return Promise.reject(
                          t("ResetPassword.newPasswordErrorMessage")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                  {
                    pattern: appConstConfig.PASSWORD_VALIDATION_REGEX,
                    message: t("CommonUtils.invalidPassword"),
                  },
                ]}
                normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <Input.Password
                  placeholder={t("ResetPassword.newPasswordPlaceholder")}
                  iconRender={(visible) =>
                    visible ? <EyeTwoTone style={{fontSize:16}}/> : <EyeInvisibleOutlined style={{fontSize:16}}/>
                  }
                />
              </Form.Item>

              <Form.Item
                label={
                  <RequiredLabel
                    text={t("ResetPassword.confirmPasswordLabel")}
                    required={true}
                  />
                }
                name={"password2"}
                className={styles.labelTextStyle}
                rules={[
                  {
                    required: true,
                    message: t("ResetPassword.confirmPasswordErrorMessage"),
                  },
                  {
                    validator: (_, value) => {
                      if (value && /\s/.test(value)) {
                        return Promise.reject(
                          t("ResetPassword.confirmPasswordErrorMessage")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <Input.Password
                  placeholder={t("ResetPassword.confirmPasswordPlaceholder")}
                  iconRender={(visible) =>
                    visible ? <EyeTwoTone style={{fontSize:16}}/> : <EyeInvisibleOutlined style={{fontSize:16}}/>
                  }
                />
              </Form.Item>
            </div>

            <Button
              type="primary"
              className={styles.buttonStyle}
              htmlType="submit"
              loading={loading}
            >
              {t("ResetPassword.confirm")}
            </Button>
          </Flex>
        </Form>
      </Flex>
    </>
  );
};

export default NewPassword;
